"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'userGroup.error.create': 'Error al crear el grupo de usuarios',
};
